<style lang="scss">
</style>

<template>
    <div>
        <!-- <Breadcrumb class="tablelist-header">
            <BreadcrumbItem >{{title}}</BreadcrumbItem>
        </Breadcrumb> -->
        <compUpdateDetail v-if="type==='add'||(type==='edit'&&status=='establish')" :type="type" :data='formData' ref="form"/>
        <compDetail v-if="(type==='edit'&&(status==='outdept'||status==='confirm'))||type==='query'" :data='formData'/>
        <compAllotslist :search="type==='add'||(type==='edit'&&status=='establish')" :type='type' class="bg-fff shadow margin-top-15 padding-bottom-15" v-model="allocationItems"/>
        <compShipslist v-if="(type==='edit'&&(status==='outdept'||status==='confirm'))||type==='query'" :type='type' :id="id" class="bg-fff shadow margin-top-15" v-model="shippingItems"/>
        <footer class="text-center bg-fff padding-15"  v-if="type==='add'||type==='edit'&&(status!='outdept'&&status!='confirm')">
            <Button type="primary" class="width-15per" @click="submit">提交</Button>
            <Button class="width-15per" @click="cancel">取消</Button>
        </footer>
        <Spin size="large" fix v-if="loading"></Spin>
    </div>
</template>

<script>
import { mapState,mapGetters } from 'vuex'
import compUpdateDetail from './updateDetail'
import compDetail from './detail'
import compAllotslist from './allotslist'
import compShipslist from './shippslist'
import {
    HttpAllot, HttpUpdateAllot
} from '@/service/allotment/transfer';
export default {
    props:['activeids','querytype'],
    components: {
        compUpdateDetail,
        compAllotslist,
        compShipslist,
        compDetail,
    },
    data() {
        return {
            loading: false,
            type: this.$route.params.type,
            id: this.$route.query.id,
            status: this.$route.query.status,
            title: null,
            allocationItems: [],
            shippingItems: [],
            formData: {
                tranNo: "",
                extraData: {},
            },
            required: [{
                required: true,
                message: "该信息不能为空,请填写"
            }],
        }
    },
    created() {
        if(this.activeids){
            this.id = this.activeids
            this.type = this.querytype
        }
        this.getDetail();
        // const titles = {
        //     add: '添加Amazon移库计划',
        //     edit: '编辑Amazon移库计划',
        //     query: 'Amazon移库计划详情',
        // }
        // this.title = titles[this.type]

    },
    computed: {
        ...mapState('boss',['products']),
        ...mapGetters('boss', ['warehouses']),
    },
    methods: {
        cancel() {
            this.$router.push({ name: "tsList" })
        },
        handleResponse(data = {}) {
            this.shippingItems = data.shippingItems;
            this.allocationItems = data.allocationItems;
            this.formData = Object.assign(this.formData, data, { extraData: JSON.parse(data.extraData || "{}") });
        },
        handleFormat(data = []) {
            const obj = {};
            data.forEach((item, index) => {
                Object.keys(item).forEach(function (key) {
                    obj[`allocationItems[${index}].${key}`] = this[key]
                }, item)
            });
            return obj;
        },
        handleRequest(data) {
            let formdata = {}, type = this.type, state = this.status;
            if (type === 'add' || type === 'edit') {
                formdata = { ...data, ... this.handleFormat(this.allocationItems) };
            }
            Reflect.deleteProperty(formdata, 'allocationItems')
            if (type === 'edit') formdata.id = this.id;
            return formdata;
        },

        async getDetail() {
            if (this.type === 'add') return;
            this.loading = true;
            HttpAllot({
                id: this.id
            }).then(res => {
                this.handleResponse(res.data);
                this.loading = false;
            }, err => {
                this.loading = false;
                this.errorMessage(err.message);
            });
        },
        async submit() {
            let data = await this.$refs['form'].submit();
            if (!data) return;
            this.loading = true;
            HttpUpdateAllot(this.handleRequest(data)).then(res => {
                this.cancel();
                this.$Message.success(res.message);
            }, err => {
                this.loading = false;
                this.errorMessage(err.message);
            });
        }
    },

}
</script>

